module.exports = __webpack_public_path__ + "img/taskmanager_lock.24ea6eae.svg";